export default __webpack_public_path__ + "static/media/Coins.858f7390.svg";